import { Components, Theme } from '@mui/material'
import { palette } from '../palette'

export const MuiInputLabel: Components<Omit<Theme, 'components'>>['MuiInputLabel'] = {
  defaultProps: {
    margin: 'dense',
    shrink: true,
  },
  styleOverrides: {
    asterisk: { color: palette.error.main },
    root: {
      transform: 'scale(1)',
      position: 'static',
      fontSize: 16,
      marginBottom: 4,
    },
  },
}
